import { createContext, useContext } from "react";
import type { IGummiwormState } from "./types";

export const GummiwormContext = createContext<IGummiwormState | undefined>(
  undefined,
);

export const useGummiwormContext = () => {
  const context = useContext(GummiwormContext);
  if (context === undefined) {
    throw new Error(
      "useGummiwormContext must be used within GummiwormProvider",
    );
  }
  return context;
};
